/**
 * NotFoundPage - 404 error page component
 *
 * Displayed when users navigate to non-existent routes.
 * Provides helpful navigation back to main sections.
 */
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

function NotFoundPage() {
  return (
    <main className="not-found-page-container" role="main">
      <h1 className="not-found-page-title">404</h1>
      <h2 className="not-found-page-subtitle">Page Not Found</h2>
      <p className="not-found-page-description">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link 
        to="/" 
        className="not-found-page-link"
        aria-label="Return to QreditCharge API Homepage"
      >
        Return to Homepage
      </Link>
    </main>
  );
}

export default NotFoundPage;